import type { EraId } from '../science/types';
import type { EraVisualPackage } from './types';

const cache = new Map<EraId, Promise<EraVisualPackage>>();

const loaders: Record<EraId, () => Promise<{ default: EraVisualPackage }>> = {
  modern: () => import('./modern/package'),
  '2010s': () => import('./2010s/package'),
  '1990s-2000s': () => import('./1990s-2000s/package'),
  '1970s-1980s': () => import('./1970s-1980s/package'),
  '1950s-1960s': () => import('./1950s-1960s/package'),
  '1940s': () => import('./1940s/package')
};

export const loadEraVisualPackage = (id: EraId): Promise<EraVisualPackage> => {
  const existing = cache.get(id);
  if (existing) return existing;
  const promise = loaders[id]().then((module) => module.default);
  cache.set(id, promise);
  return promise;
};
